export const HOTJAR_TAG_SORT = 'CM Sort Candidates';
export const HOTJAR_TAG_ADD_NOTE = 'CM Add_Note';
export const HOTJAR_TAG_EMAIL = 'CM Send Email';
export const HOTJAR_TAG_BULK_ACTIONS = 'CM Bulk Actions';
export const HOTJAR_TAG_RATING = 'CM Rating';
export const HOTJAR_TAG_STATUS_CHANGE = 'CM Status Change';
export const HOTJAR_TAG_PROFILE = 'CM Profile Tab Change';
export const HOTJAR_TEAM_MEMBER_ACCESS = 'CM Team Member Access';
export const HOTJAR_FILTERS_INTERACTED = 'CM Filters Interacted';
export const HOTJAR_CERTSY_SKILLS_VIEWED = 'CM Certsy Skills Viewed';
export const HOTJAR_BUDGETS_LINK_BUTTON_CLICKED =
  'CM Budgets Link Button Clicked';
export const HOTJAR_ORDER_REFERENCE_CHECK_BUTTON_CLICKED =
  'CM Order Reference Check Button Clicked';
export const HOTJAR_VIEW_REFERENCE_CHECK_BUTTON_CLICKED =
  'CM View Reference Check Button Clicked';
export const HOTJAR_UPGRADE_REFERENCES_BUTTON_CLICKED =
  'CM Upgrade References Button Clicked';
